<template>
  <div class="page-container">

    <!-- 搜索栏 -->
    <div class="page-card">
      <div class="page-card__header">
        <el-row style="width: 100%; line-height: 40px">
          <el-col :span="4">
            <span>展会总数（共{{ aSum }}条）</span>
          </el-col>
          <el-col :span="2">
            <el-button type="primary" @click="openAddWindow">添加</el-button>
          </el-col>
          <el-col :span="6">
            <el-input v-model="input">
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="serach"
              ></el-button>
            </el-input>
          </el-col>
        </el-row>
      </div>

      <!-- 数据表格 -->
      <el-table :data="tableData" style="width: 100%; padding: 0 20px">
        <el-table-column prop="id" label="ID" width="80px"></el-table-column>
        <el-table-column prop="name" label="展会名"></el-table-column>
        <el-table-column prop="name_en" label="展会英文名"></el-table-column>
        <el-table-column prop="sponsor" label="展览公司"></el-table-column>
        <el-table-column prop="address" label="展会地址"></el-table-column>
        <el-table-column prop="time" label="时间"></el-table-column>
        <el-table-column prop="image" label="LOGO">
          <template slot-scope="scope">
            <div style="display: flex; gap: 5px">
              <el-image
                v-for="(img, index) in scope.row.image"
                :key="index"
                style="width: 100px;max-height: 100px"
                :src="ImagesUri + img.trim()"
                fit="fill"
                :preview-src-list="getPreviewImages(scope.row.image)"
              >
              </el-image>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="create_time"
          label="填写时间"
          width="160"
          sortable
        ></el-table-column>

        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="updateClick(scope.row)"
            >修改
            </el-button>
            <el-button
              type="text"
              class="action-btn--danger"
              @click="handleClick(scope.row)"
            >删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页器 -->
      <div class="pagination-wrap">
        <el-pagination
          @current-change="handleCurrentChange"
          :page-size="pagesize"
          :total="aSum"
          :page-count="pageCount"
          :current-page.sync="currentPage"
          background
          layout="prev, pager, next,jumper"
        >
        </el-pagination>
      </div>
    </div>

    <!-- 弹窗 - 添加展会 -->
    <el-dialog
      title="添加展会"
      :visible.sync="addTotalVisible"
      :closed="cancel"
      width="1000px"
      :close-on-click-modal="false"
      style="text-align: center"
    >
      <el-form label-width="100px" ref="form" :model="form" :rules="formRules">
        <el-form-item label="LOGO" prop="images">
          <el-upload
            :action="imagesrc"
            :file-list="fileList"
            :on-success="P_handleListSuccess"
            :on-remove="p_handleRemove"
            :before-upload="beforeAvatarUpload"
            list-type="picture-card"
            :headers="headers"
            :limit="1"
            :class="{'logo-upload-full': fileList.length >= 1}"
          >
            <i slot="default" class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>

        <el-row>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="展会名：" style="text-align: left" prop="name">
              <el-input v-model="form.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="展会英文名：" style="text-align: left" prop="name_en">
              <el-input v-model="form.name_en"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="主办方：" style="text-align: left" prop="sponsor">
              <el-input v-model="form.sponsor"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="展会日期：" style="text-align: left" prop="time">
              <el-input v-model="form.time"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="开始日期：" style="text-align: left" prop="start_time">
              <el-input type="date" v-model="form.start_time"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="结束日期：" style="text-align: left" prop="end_time">
              <el-input type="date" v-model="form.end_time"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="展会地址：" style="text-align: left" prop="address">
          <el-input v-model="form.address"></el-input>
        </el-form-item>

        <el-form-item label="微信文章" style="text-align: left" prop="article">
          <el-input v-model="form.article"></el-input>
        </el-form-item>

        <el-form-item label="视频号链接：" style="text-align: left" prop="feed_token">
          <el-input v-model="form.feed_token"></el-input>
        </el-form-item>

        <el-form-item label="展会详情：" style="text-align: left" prop="info">
          <el-input v-model="form.info" type="textarea" :rows="10"></el-input>
        </el-form-item>

        <el-form-item label="展会图片">
          <el-upload
            :action="imagesrc"
            :file-list="pictureFileList"
            :on-success="P_handlePictureSuccess"
            :on-remove="p_pictureRemove"
            :before-upload="beforeAvatarUpload"
            list-type="picture-card"
            :headers="headers"
          >
            <i slot="default" class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submitAdd('form')">
            确认提交
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  import api from "../../utils/api";
  export default {
    name: "cnThaList",
    filters: {
      /**
       * 状态过滤器
       * @param {string} status - 状态值
       * @returns {string} 对应的Element UI类型
       */
      statusFilter(status) {
        const statusMap = {
          published: 'success',
          draft: 'gray',
          deleted: 'danger'
        }
        return statusMap[status]
      }
    },
    data() {
      return {
        // 添加弹窗显示状态
        addTotalVisible: false,
        // 表单数据
        form: {
          name: '',
          name_en: '',
          sponsor: '',
          id: '',
          address: '',
          time: '',
          info: '',
        },
        // 表格数据
        tableData: [],
        // 总页数
        pageCount: 1,
        // 每页显示条目数
        pagesize: 10,
        // 当前页数
        currentPage: 1,
        // 总条目数
        aSum: 0,
        // 搜索关键字
        input: "",
        // 表单验证规则
        formRules: {
          name: [{required: true, message: '请输入展会名称', trigger: 'blur'}],
          name_en: [{required: true, message: '请输入展会英文名称', trigger: 'blur'}],
          sponsor: [{required: true, message: '请输入展览公司', trigger: 'blur'}],
          time: [{required: true, message: '请输入展会时间', trigger: 'blur'}],
          address: [{required: true, message: '请输入展会地址', trigger: 'blur'}],
          info: [{required: true, message: '请输入展会内容', trigger: 'blur'}]
        },
        // 上传文件列表
        fileList: [],
        // 展会图片文件列表
        pictureFileList: [],
        // 图片上传地址
        imagesrc: this.baseUrl + "/admin/uploadfile/survey_exh/",
        // 上传请求头
        headers: {Authorization: "JWT " + localStorage.getItem("adminToken")},
        // 图片基础地址
        ImagesUri: "https://cloudexhibition.oss-cn-shenzhen.aliyuncs.com/survey_exh/",
      };
    },

    mounted() {
      // 页面加载时获取展会列表
      this.getData();
    },
    methods: {
      /**
       * 打开添加展会弹窗并重置表单
       */
      openAddWindow() {
        this.addTotalVisible = true
        this.form = {}
        this.fileList = []
        this.pictureFileList = []
      },

      /**
       * 取消操作，关闭弹窗并重置表单
       */
      cancel() {
        this.addTotalVisible = false;
        this.form = {}
      },

      /**
       * 获取展会列表数据
       * 解析图片字段为数组格式
       */
      getData() {
        let url = this.baseUrl + "/admin/survey_exh/";
        api.fetchData(url).then((res) => {
          for (let i = 0; i < res.results.length; i++) {
            if (res.results[i].image !== '' && res.results[i].image !== null) {
              res.results[i].image = res.results[i].image.split(',')
            } else {
              res.results[i].image = []
            }
          }
          this.tableData = res.results;
          this.aSum = res.count;
          this.currentPage = 1;
        });
      },

      /**
       * 搜索展会数据
       */
      serach() {
        let url = this.baseUrl + "/admin/survey_exh/?search=" + this.input;
        api.fetchData(url).then((res) => {
          for (let i = 0; i < res.results.length; i++) {
            if (res.results[i].image !== '' && res.results[i].image !== null) {
              res.results[i].image = res.results[i].image.split(',')
            } else {
              res.results[i].image = []
            }
          }
          this.tableData = res.results;
          this.aSum = res.count;
          this.currentPage = 1;
        });
      },

      /**
       * 分页切换处理
       * @param {number} val - 目标页码
       */
      handleCurrentChange(val) {
        let url =
          this.baseUrl + "/admin/survey_exh/?type=2&page=" + val + "&search=" + this.input;
        api.fetchData(url).then((res) => {
          for (let i = 0; i < res.results.length; i++) {
            if (res.results[i].image !== '' && res.results[i].image !== null) {
              res.results[i].image = res.results[i].image.split(',')
            } else {
              res.results[i].image = []
            }
          }
          this.tableData = res.results;
          this.aSum = res.count;
          this.currentPage = val;
        });
      },

      /**
       * 删除展会信息
       * @param {object} row - 当前行数据
       */
      handleClick(row) {
        this.$confirm("将删除此条信息，是否继续", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          let a_id = row.id;
          let url = this.baseUrl + "/admin/survey_exh/" + a_id + "/";
          api.deleteData(url).then((res) => {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.getData();
          });
        });
      },

      /**
       * 提交新增或修改展会表单
       * 根据form.id判断是新增还是修改操作
       */
      submitAdd() {
        const images = this.fileList.map((item) => item.name).join(",");
        this.form.image = images;
        const pictures = this.pictureFileList.map((item) => item.name).join(",");
        this.form.picture = pictures;
        this.$refs['form'].validate((valid) => {
            if (valid) {
              if (this.form.id) {
                let url = this.baseUrl + '/admin/survey_exh/' + this.form.id + '/';
                api.putData(url, this.form).then((response) => {
                  if (response.status === 200) {
                    this.$message({
                      message: "修改成功",
                      type: "success",
                    });
                    this.addTotalVisible = false;
                    this.form = [];
                    this.getData()
                    this.fileList = []
                  }
                });
              } else {
                let posturl = this.baseUrl + '/admin/survey_exh/';
                api.postData(posturl, this.form).then((response) => {
                  this.$message({
                    message: '新增成功',
                    type: 'success'
                  })
                  this.addTotalVisible = false;
                  this.getData()
                  this.fileList = []
                })
              }
            }
          }
        )
      },

      /**
       * 打开修改弹窗并初始化表单数据
       * @param {object} e - 当前行数据
       */
      updateClick(e) {
        this.initImage(e);
        this.initPicture(e);
        this.addTotalVisible = true
        this.form = JSON.parse(JSON.stringify(e));
      },

      /**
       * 添加弹窗 - 图片移除处理
       * @param {object} file - 被移除的文件
       * @param {Array} fileList - 当前文件列表
       */
      p_handleRemove(file, fileList) {
        this.fileList = fileList;
      },

      /**
       * 图片上传成功回调
       * @param {object} res - 服务器响应
       * @param {object} file - 上传的文件
       */
      P_handleListSuccess(res, file) {
        this.fileList.push({
          name: file.response.filename,
          url: this.ImagesUri + file.response.filename,
        });
      },

      /**
       * 展会图片上传成功回调
       */
      P_handlePictureSuccess(res, file) {
        this.pictureFileList.push({
          name: file.response.filename,
          url: this.ImagesUri + file.response.filename,
        });
      },

      /**
       * 展会图片移除处理
       */
      p_pictureRemove(file, fileList) {
        this.pictureFileList = fileList;
      },

      /**
       * 图片上传前校验
       * @param {object} file - 待上传的文件
       * @returns {boolean} 是否通过校验
       */
      beforeAvatarUpload(file) {
        const isJPG = file.type === "image/jpeg" || file.type === "image/png";

        if (!isJPG) {
          this.$message.error("上传图片只能是 JPG 或 PNG 格式!");
        }

        return isJPG;
      },

      /**
       * 获取图片预览列表
       * @param {Array} imagesStr - 图片文件名数组
       * @returns {Array} 完整图片URL数组
       */
      getPreviewImages(imagesStr) {
        return imagesStr
          .map((img) => this.ImagesUri + img);
      },

      /**
       * 初始化编辑弹窗的图片列表
       * @param {object} row - 当前行数据
       */
      initImage(row) {
        this.fileList = [];
        if (row.image != null && row.image != "") {
          let imgs = row.image;
          for (var i of imgs) {
            this.fileList.push({name: i, url: this.ImagesUri + i});
          }
        }
      },

      /**
       * 初始化编辑弹窗的展会图片列表
       */
      initPicture(row) {
        this.pictureFileList = [];
        if (row.picture != null && row.picture != "") {
          let imgs = row.picture.split(",");
          for (var i of imgs) {
            this.pictureFileList.push({name: i, url: this.ImagesUri + i});
          }
        }
      },
    },
  };
</script>

<style scoped>
  ::v-deep .vue-html5-editor > .content {
    max-height: 600px;
  }
  ::v-deep .logo-upload-full .el-upload--picture-card {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/surveyList.vue